module.exports = __webpack_public_path__ + "img/3.fcf18364.png";